import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "document-list-filter__row" }
const _hoisted_2 = { class: "document-list-filter__row-group" }
const _hoisted_3 = { class: "document-list-filter__row-group" }
const _hoisted_4 = { class: "document-list-filter__row-group" }
const _hoisted_5 = { class: "document-list-filter__row" }
const _hoisted_6 = { class: "document-list-filter__row-range" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HintComponent = _resolveComponent("HintComponent")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "documentListFilterFormRef",
    rules: _ctx.documentListFilterFormRules,
    disabled: _ctx.isDocumentListLoading,
    class: "document-list-filter",
    model: _ctx.documentListFilterFormData,
    "label-position": "top",
    "validate-on-rule-change": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, { size: "small" }, {
            label: _withCtx(() => [
              _createVNode(_component_HintComponent, {
                "hint-list": _ctx.DOCUMENT_HINT_MAP,
                name: _ctx.DocumentHintNames.TAGS
              }, null, 8 /* PROPS */, ["hint-list", "name"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.documentListFilterFormData.tagList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.documentListFilterFormData.tagList) = $event)),
                loading: _ctx.isTagListLoading,
                placeholder: "Select tags",
                multiple: "",
                "fit-input-width": "",
                clearable: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                filterable: "",
                "popper-class": "document-list-filter__row-group-select-popover",
                "no-data-text": _ctx.noDataTagIdListText,
                "remote-method": _ctx.remoteTagIdListMethod,
                remote: "",
                "value-key": "tagId",
                onChange: _ctx.changeTagIdList,
                onVisibleChange: _ctx.changeTagIdListVisible
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagOptionList, (tagOptionListItem) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: tagOptionListItem.tagId,
                      label: tagOptionListItem.name,
                      value: tagOptionListItem
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading", "no-data-text", "remote-method", "onChange", "onVisibleChange"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "Condition",
            prop: _ctx.DocumentListFilterProperties.TAG_ID_LIST_CONDITION,
            size: "small",
            "show-message": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.documentListFilterFormData.tagIdListCondition,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.documentListFilterFormData.tagIdListCondition) = $event)),
                disabled: !_ctx.isFilterTagIdListNotEmpty,
                "popper-class": "document-list-filter__row-group-select-popover",
                loading: _ctx.isConditionListLoading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionList, ({ label, value }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: label,
                      label: label,
                      value: value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, { size: "small" }, {
            label: _withCtx(() => [
              _createVNode(_component_HintComponent, {
                "hint-list": _ctx.DOCUMENT_HINT_MAP,
                name: _ctx.DocumentHintNames.SEGMENTS
              }, null, 8 /* PROPS */, ["hint-list", "name"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.documentListFilterFormData.segmentList,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.documentListFilterFormData.segmentList) = $event)),
                loading: _ctx.isSegmentListLoading,
                placeholder: "Select segments",
                multiple: "",
                "fit-input-width": "",
                clearable: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                filterable: "",
                "popper-class": "document-list-filter__row-group-select-popover",
                "remote-method": _ctx.remoteSegmentsIdListMethod,
                "no-data-text": _ctx.noDataSegmentIdListText,
                remote: "",
                "value-key": "id",
                onChange: _ctx.changeSegmentList,
                onVisibleChange: _ctx.changeSegmentIdListVisible
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentOptionList, (segmentOptionListItem) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: segmentOptionListItem.id,
                      label: segmentOptionListItem.name,
                      value: segmentOptionListItem
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading", "remote-method", "no-data-text", "onChange", "onVisibleChange"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "Condition",
            size: "small",
            prop: _ctx.DocumentListFilterProperties.SEGMENT_ID_LIST_CONDITION,
            "show-message": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.documentListFilterFormData.segmentIdListCondition,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.documentListFilterFormData.segmentIdListCondition) = $event)),
                disabled: !_ctx.isFilterSegmentIdListNotEmpty,
                "popper-class": "document-list-filter__row-group-select-popover",
                "show-message": false,
                loading: _ctx.isConditionListLoading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionList, ({ label, value }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: label,
                      label: label,
                      value: value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, {
            label: "Country",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.documentListFilterFormData.countryList,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.documentListFilterFormData.countryList) = $event)),
                "popper-class": "document-list-filter__row-group-select-popover",
                loading: _ctx.isCountryListLoading,
                placeholder: "Select countries",
                multiple: "",
                "fit-input-width": "",
                clearable: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                filterable: "",
                onVisibleChange: _ctx.loadCountryListOnVisibleChange,
                onChange: _ctx.changeCountryList
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryList, ({ code, name }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: code,
                      label: name,
                      value: code
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading", "onVisibleChange", "onChange"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "Condition",
            size: "small",
            prop: _ctx.DocumentListFilterProperties.COUNTRY_LIST_CONDITION,
            "show-message": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.documentListFilterFormData.countryListCondition,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.documentListFilterFormData.countryListCondition) = $event)),
                disabled: !_ctx.isFilterCountryListNotEmpty,
                "popper-class": "document-list-filter__row-group-select-popover",
                "show-message": false,
                loading: _ctx.isConditionListLoading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excludeAndConditionList, ({ label, value }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: label,
                      label: label,
                      value: value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form_item, {
            label: "Min total balance EUR",
            size: "small",
            prop: _ctx.DocumentListFilterProperties.MIN_TOTAL_AMOUNT_EUR
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.documentListFilterFormData.minTotalAmountEur,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.documentListFilterFormData.minTotalAmountEur) = $event)),
                placeholder: "Enter min total balance EUR",
                clearable: "",
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setMinTotalAmountEur($event)))
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"]),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "–", -1 /* CACHED */)),
          _createVNode(_component_el_form_item, {
            label: "Max total balance EUR",
            size: "small",
            prop: _ctx.DocumentListFilterProperties.MAX_TOTAL_AMOUNT_EUR
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.documentListFilterFormData.maxTotalAmountEur,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.documentListFilterFormData.maxTotalAmountEur) = $event)),
                placeholder: "Enter max total balance EUR",
                clearable: "",
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setMaxTotalAmountEur($event)))
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"])
        ]),
        (_ctx.isGetDocumentModerationFilterStatusListAllowed)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Document status",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.documentListFilterFormData.moderationStatus,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.documentListFilterFormData.moderationStatus) = $event)),
                  "popper-class": "document-list-filter__row-group-select-popover",
                  loading: _ctx.isDocumentModerationFilterStatusListLoading,
                  placeholder: "Select status",
                  "fit-input-width": "",
                  clearable: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  filterable: "",
                  onVisibleChange: _ctx.loadDocumentModerationFilterStatusListOnVisibleChange,
                  onChange: _ctx.changeCountryList
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excludeAllDocumentModerationFilterStatusList, ({ label, value }) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: value,
                        label: label,
                        value: value
                      }, null, 8 /* PROPS */, ["label", "value"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "loading", "onVisibleChange", "onChange"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["rules", "disabled", "model"]))
}